const serverURL = 'https://areezvisram-backend.herokuapp.com';

module.exports = {
    serverURL
}